import { i18n } from "@lingui/core";
import { useEffect } from "react";
import { getSelectedLocale, setSelectedLocale } from "./store";

export function useDefaultLocale(
  locale: string | undefined | null,
  force?: boolean,
) {
  useEffect(() => {
    if (locale == null) return;

    if (force) {
      i18n.activate(locale);
      return;
    }

    const selected = getSelectedLocale();
    if (selected == null) {
      i18n.activate(locale);
    }
  }, [locale, force]);
}

export function selectLocale(locale: string) {
  i18n.activate(locale);
  setSelectedLocale(locale);
}
